import { z } from 'zod'

export const taskTypeSchema = z.enum(['call', 'email', 'meeting', 'task'])
export const taskPrioritySchema = z.enum(['low', 'normal', 'high', 'urgent'])
export const taskLinkedEntityTypeSchema = z.enum([
  'order',
  'customer',
  'product',
  'material',
  'supplier',
  'invoice',
  'payment_request',
  'shipment',
  'production_order',
  'engineering',
])
const id = z.string().trim().min(1).max(200)
const instant = z.iso.datetime({ offset: true }).nullable()
const fields = {
  title: z.string().trim().min(1).max(500),
  notes: z.string().trim().max(20_000).nullable(),
  type: taskTypeSchema,
  priority: taskPrioritySchema,
  assigneeId: id,
  dueAt: instant,
  reminderAt: instant,
  dealId: id.nullable(),
  linkedEntityType: taskLinkedEntityTypeSchema.nullable(),
  linkedEntityId: id.nullable(),
}

export const taskCreateSchema = z
  .object({
    requestId: z.uuid(),
    title: fields.title,
    notes: fields.notes.optional(),
    type: fields.type.optional(),
    priority: fields.priority.optional(),
    assigneeId: fields.assigneeId.optional(),
    dueAt: fields.dueAt.optional(),
    reminderAt: fields.reminderAt.optional(),
    dealId: fields.dealId.optional(),
    linkedEntityType: fields.linkedEntityType.optional(),
    linkedEntityId: fields.linkedEntityId.optional(),
  })
  .strict()
export type TaskCreateInput = z.infer<typeof taskCreateSchema>

export const taskUpdateSchema = z
  .object({
    id,
    version: z.number().int().positive(),
    title: fields.title.optional(),
    notes: fields.notes.optional(),
    type: fields.type.optional(),
    priority: fields.priority.optional(),
    assigneeId: fields.assigneeId.optional(),
    dueAt: fields.dueAt.optional(),
    reminderAt: fields.reminderAt.optional(),
    dealId: fields.dealId.optional(),
    linkedEntityType: fields.linkedEntityType.optional(),
    linkedEntityId: fields.linkedEntityId.optional(),
  })
  .strict()
  .refine((input) => Object.keys(input).some((key) => key !== 'id' && key !== 'version'))
export type TaskUpdateInput = z.infer<typeof taskUpdateSchema>

export const taskTransitionSchema = z
  .object({ id, version: z.number().int().positive(), requestId: z.uuid().optional() })
  .strict()
export type TaskTransitionInput = z.infer<typeof taskTransitionSchema>
export const taskAssignSchema = taskTransitionSchema.extend({ assigneeId: id })
export type TaskAssignInput = z.infer<typeof taskAssignSchema>
export const taskDismissSchema = z
  .object({
    id: z
      .string()
      .max(400)
      .regex(
        /^(notice|handoff|eng|eng-unassigned|issue|shortage|critical|purchase-request|receipt|stage|ship|invoice|payment|approval|pay-supplier)-[A-Za-z0-9_-]+$/,
      ),
  })
  .strict()
export type TaskDismissInput = z.infer<typeof taskDismissSchema>
